import { styled } from '@mui/material/styles';

export const DropdownContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),

  height: 36, // Reduced from 40
  padding: '0 12px',
  flexShrink: 1,

  overflow: 'hidden',
  whiteSpace: 'nowrap',

  border: `1px solid ${theme.palette.grey[300]}`,
  borderRadius: theme.shape.borderRadius,
  backgroundColor: theme.palette.background.paper,
  cursor: 'pointer',

  '&:hover': {
    borderColor: theme.palette.text.primary,
  },
}));


export const SortDisplay = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
}));


export const SortText = styled('span')(({ theme }) => ({
  fontSize: '0.85rem', // Reduced from 14px
  display: 'flex',
  alignItems: 'center',
  '& strong': {
    fontWeight: 600,
    color: theme.palette.text.primary,
    marginLeft: 4,
  }
}));


export const DropdownListWrapper = styled('div')(({ theme }) => ({
  position: 'absolute',
  top: '100%',
  right: 0,
  left: 'auto',
  marginTop: 8,
  backgroundColor: theme.palette.background.paper,
  borderRadius: 8,
  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
  minWidth: 250,
  zIndex: 1300,
  padding: '8px 0',
  transform: 'none',
}));


export const DropdownListItem = styled('div', {
  shouldForwardProp: (prop) => prop !== '$isActive',
})<{ $isActive: boolean }>(({ theme, $isActive }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '10px 16px',
  cursor: 'pointer',
  fontSize: 15,
  color: $isActive
    ? theme.palette.primary.main
    : theme.palette.text.secondary,
  fontWeight: $isActive ? 600 : 400,
  '&:hover': {
    backgroundColor: '#f0f4f7',
  },
}));
